window.primaryColor = '#1f436c';
require('./common.js');
require('../pages/outings/init.js');
require('stylesheets/theme/outings');
